import React  from "react";
import { connect } from "react-redux";
import InvoiceItemTable from "./InvoiceItemTable";

const MyInvoiceDetails = ({recordData, ...props}) => {
	
	return (
	    <div>
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
			 	{recordData && (
			 		<InvoiceItemTable invoiceData={recordData}/>
		      	)}
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
  recordData: state.invoice.invoiceDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
  
});

export default connect(mapStateToProps, mapDispatchToProps)(MyInvoiceDetails);
